import React from 'react'
import { useRouteError } from 'react-router-dom';


export default function ErrorPage({msg}: {msg: string}) {
  const error = useRouteError() as Error;
  return (
    <div className="text-center mt-3">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred:</p>
      <p>
        <i>{msg}</i>
        {error.message && <i>{error.message}</i>}
      </p>
    </div>
  );
}